module.exports = __webpack_public_path__ + "static/media/hubertus.4cca2e5a.jpg";